// classStrg supports multiple classes separated by commas
// class names only don't pre-append '.'
// REQUIRES: 
// * util-set-classes.js
const setClassIfVisible = function (elem, classStrg) {
  if (!elem || !classStrg) return;

  const classArry = classStrg.split(",");
  const supportsObserver = ("IntersectionObserver" in window && "IntersectionObserverEntry" in window && "intersectionRatio" in window.IntersectionObserverEntry.prototype);

  // If it doesn't support an observer
  // we fallback into just showing it
  if (!supportsObserver) {
    setClasses(elem, classArry);
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    if (entries[0].isIntersecting) {
      setClasses(entries[0].target, classArry);
      observer.unobserve(entries[0].target);
    }
  });
  observer.observe(elem);
}